import * as React from "react";

/** A block that can be read two ways, with its switch above the content rather than inside it. */
export function ToggledView({
  toggle,
  children,
}: {
  toggle: React.ReactNode;
  children: React.ReactNode;
}) {
  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex justify-end">{toggle}</div>
      {children}
    </div>
  );
}
